import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const listUploadS3PublicShareTokens = (params) =>
  axios.get(`${BASE_URL}/admin/upload-s3-public-share-token`, {
    params,
    headers: getAuthHeaders(),
  });

export const exportUploadS3PublicShareTokens = (params) =>
  axios.get(`${BASE_URL}/admin/upload-s3-public-share-token/export`, {
    params,
    headers: getAuthHeaders(),
    responseType: "blob",
  });

export const getUploadS3PublicShareToken = (id) =>
  axios.get(`${BASE_URL}/admin/upload-s3-public-share-token/${id}`, {
    headers: getAuthHeaders(),
  });

export const updateUploadS3PublicShareToken = (id, data) =>
  axios.put(`${BASE_URL}/admin/upload-s3-public-share-token/${id}`, data, {
    headers: getAuthHeaders(),
  });

export const toggleUploadS3PublicShareTokenActive = (id) =>
  axios.patch(
    `${BASE_URL}/admin/upload-s3-public-share-token/${id}/active`,
    {},
    { headers: getAuthHeaders() }
  );

export const regenerateUploadS3PublicShareToken = (id) =>
  axios.post(
    `${BASE_URL}/admin/upload-s3-public-share-token/${id}/regenerate-token`,
    {},
    { headers: getAuthHeaders() }
  );

export const viewUploadS3PublicShareTokenSourceFile = (id) =>
  axios.get(`${BASE_URL}/admin/upload-s3-public-share-token/${id}/source-file`, {
    headers: getAuthHeaders(),
  });
